import $ from 'jquery';

class PageLoader {
  constructor() {
    this.pageloader = $('.js-pageloader');

    if (!this.pageloader.length) {
      return;
    }

    this.init();
  }

  init() {
    $(window).on('load', () => {
      this.pageloader.fadeOut(500, () => {
        this.pageloader.remove();
      });
    });
  }
}

export default new PageLoader();



// WEBPACK FOOTER //
// ./src/scripts/modules/pageloader.js